import { render, staticRenderFns } from "./Selectuser.vue?vue&type=template&id=dd80c648"
import script from "./Selectuser.vue?vue&type=script&lang=js"
export * from "./Selectuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports